import type { SitGo } from './types';

/**
 * A Sit & Go lobby row's variant (PLO or NLH), for the lobby's Sit & Go tiles:
 * their banner and label. What a table is subscribed as is the row's engine
 * `game`, not this (see sngRegistrationPlaceholder in useActiveTables).
 *
 * Same gameType-vs-displayName asymmetry as the cash variant detection — see
 * EN-10379 in SaloonLobbyContainer.
 */
export const detectSitgoVariant = (raw: any): SitGo['variant'] => {
  const gameType = String(raw?.gameType ?? '');
  const displayName = String(raw?.gameTypeDisplayName ?? '').toLowerCase();
  if (
    gameType.includes('HiLo') ||
    /^(PLO|NLO)\b/i.test(gameType) ||
    displayName.includes('omaha') ||
    displayName.includes('plo')
  ) {
    return 'PLO';
  }
  return 'NLH';
};
